<pdq-button
  pdqPopover
  [active]="isOpen"
  variant="ghost"
  label="Sync orders"
  forcePosition="bottom_right"
  [popoverTemplate]="syncOrdersOptions"></pdq-button>
<ng-template #syncOrdersOptions>
  <pdq-popover-container [loading]="false">
    <div class="container">
      <div class="title">Select conditions</div>
      <div class="conditions">
        @for (control of conditionsForm?.controls; track control; let i = $index) {
          <div class="conditions__row">
            <div class="conditions__inputs">
              <div class="conditions__input">
                <pdq-dropdown
                  placeholder="Pick condition"
                  (onChange)="setCondition($event, i)"
                  [options]="allConditions | IFilterUniqueOptions: conditionsForm.value : control.value.conditionName"
                  [defaultOption]="NAME_TO_CONDITION[control?.value?.conditionName] | IFilterOptionPipe"></pdq-dropdown>
              </div>
              <div class="conditions__input">
                @switch (NAME_TO_CONDITION[control?.value?.conditionName]?.type) {
                  <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                  @case (ConditionType.DATE_RANGE) {
                    <app-custom-datepicker (changeDateRange)="setDateRangeValue($event, i)"></app-custom-datepicker>
                  }
                  @case (ConditionType.TEXT) {
                    <pdq-input [control]="control.controls.conditionValue"></pdq-input>
                  }
                }
              </div>
            </div>
            @if (conditionsForm?.controls?.length > 1) {
              <pdq-button
                iconColor="var(--on-surface-light)"
                icon="close"
                variant="ghost"
                (onClick)="removeCondition(i)"></pdq-button>
            }
          </div>
        }
      </div>
      @if (conditionsForm?.controls?.length !== allConditions?.length) {
        <pdq-button (onClick)="addCondition()" plain="true" variant="light" label="+Add condition"></pdq-button>
      }
    </div>
    <footer>
      <pdq-button (onClick)="closePopover()" variant="light" label="Cancel" [disabled]="syncLoading"></pdq-button>
      <pdq-button (onClick)="syncHandler()" variant="primary" label="Sync orders" [loading]="syncLoading"></pdq-button>
    </footer>
  </pdq-popover-container>
</ng-template>
